import React, { useEffect, useRef, useState } from 'react';

import HeaderNav from './HeaderNav/HeaderNav';
import HeaderActions from './HeaderActions/HeaderActions';
import HeaderMobile from './HeaderActions/HeaderMobile/HeaderMobile';

const Header = () => {
  const token = JSON.parse(localStorage.getItem('token'));

  const [openMenu, setOpenMenu] = useState(false);
  const headerRef = useRef(null);
  
  const openClass = openMenu ? 'open' : '';
  const classes = [openClass].filter(Boolean).join(' ');

  useEffect(() => {
    const notification = document.querySelector('.header-actions__notification');
    const burger = document.querySelector('.header-burger');

    if(burger) {
      burger.style.zIndex = 31;
    }

    if(notification) {
      notification.style.zIndex = 10;
    }
  }, [openClass]);

  // Реальна висота шапки → CSS-змінна --header-h. Шапка fixed, а її висота різна
  // (є/немає меню після логіну, мобільний, WebApp у Telegram), тому відступ контенту
  // і sticky-заголовки сторінок (.head) не можуть бути захардкоджені в px.
  useEffect(() => {
    const header = headerRef.current;
    if (!header) return undefined;

    const applyHeight = () => {
      document.documentElement.style.setProperty('--header-h', `${header.offsetHeight}px`);
    };

    applyHeight();

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', applyHeight);
      return () => window.removeEventListener('resize', applyHeight);
    }

    const observer = new ResizeObserver(applyHeight);
    observer.observe(header);
    return () => observer.disconnect();
  }, [token]);

  return (
    <header className={`header ${classes}`} ref={headerRef}>

      <nav>
        <HeaderActions setOpenMenu={setOpenMenu} token={token} />
        {token &&
          <>
            <HeaderNav />
            <HeaderMobile setOpenMenu={setOpenMenu} />
          </>
        }
      </nav>

  </header>
  );
};

export default Header;